import { LikeFilled, LikeOutlined } from '@ant-design/icons'
import { getOperationName } from '@apollo/client/utilities'
import cls from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GetPostListDocument, RequestedPostFragment, usePostLikeToggleMutation } from '@/generated/graphql'

import s from './post-like.module.less'

interface PostLikeProps {
  post: RequestedPostFragment
  disableActionText?: boolean
}

export const PostLike: React.FC<PostLikeProps> = ({ post, disableActionText = false }) => {
  const [changeLike, { loading }] = usePostLikeToggleMutation({
    refetchQueries: [getOperationName(GetPostListDocument)!],
  })
  const [t] = useTranslation()

  const onClick = () => {
    if (loading) {
      return
    }
    changeLike({
      variables: {
        postId: post.postId,
        like: !post.liked,
      },
    })
  }

  return (
    <div className={cls(s.container, { [s.like]: post.liked })} onClick={onClick}>
      {post.liked ? <LikeFilled /> : <LikeOutlined />}
      {!disableActionText && t('post.like')}
    </div>
  )
}
